import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

const images = document.querySelectorAll('.image')

Array.from(images).forEach((elImage) => {
    elImage.addEventListener('lazyloaded', () => {
        elImage.classList.add('-loaded')
    })

    ScrollTrigger.create({
        trigger: elImage,
        start: 'top bottom-=50px',
        once: true,
        toggleClass: '-inView',
    })
})
